import Header from "./lead/Header";
import About from "./lead/About";
import Service from "./lead/Service";
import LatestProjects from "./lead/LatestProjects";
import Contact from "./lead/Contact";
import ArrowToHeader from "./other/tools/ArrowToHeader";
import Pricing from "./lead/Pricing";
import IconSphere from "./other/animations/IconSphere";

export default function Main() {
    return (
        <>
            <div style={{marginTop: '60px'}}></div>
            <ArrowToHeader />
            <Header />
            <About />
            <Service />
            <LatestProjects />
            <Pricing />
            <IconSphere />
            <Contact />
        </>
    )
}